import React from 'react';
import BlogCard from '@/components/blog/BlogCard';
import { blogPosts } from '@/lib/blogData';
import { Badge } from '@/components/ui/badge';
import { FeaturedPost } from '@/components/blog/index/FeaturedPost';
import { BlogFilterTabs } from '@/components/blog/index/BlogFilterTabs';
import { NewsletterCTA } from '@/components/blog/index/NewsletterCTA';
import SEO from '@/components/seo/SEO';

const BlogIndexPage: React.FC = () => {
  // Sort posts by date descending
  const sortedPosts = blogPosts.filter((post) => post.indexable !== false).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  const featuredPost = sortedPosts[0];
  const regularPosts = sortedPosts.slice(1);

  return (
    <div className="page-shell">
      <SEO 
        title="Blog - SWPPP Compliance Insights"
        description="Expert advice on stormwater pollution prevention, EPA regulations, and site inspection best practices."
        canonical="/blog"
      />

      {/* Header */}
      <div className="page-intro mb-14 text-center md:mb-20">
       <div className="container relative z-10 px-4">
         <Badge variant="outline" className="mb-6 py-1.5 px-4 text-sm border-primary/20 bg-primary/5 text-primary font-medium rounded-full">
            The RunOffTrack Blog
         </Badge>
         <h1 className="mb-6 text-4xl font-black tracking-[-0.045em] text-foreground md:text-6xl">
            Insights for modern <br className="hidden md:block" />
            environmental compliance.
         </h1>
         <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Expert advice on stormwater management, EPA regulations, and site safety.
         </p>
       </div>
      </div>

      <div className="container px-4 pb-24">
        {/* Featured Post */}
        {featuredPost && <FeaturedPost post={featuredPost} />}

        {/* Filter Tabs */}
        <BlogFilterTabs />

        {/* Post Grid */}
        {regularPosts.length > 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
            {regularPosts.map((post) => (
                <BlogCard key={post.slug} {...post} />
            ))}
            </div>
        ) : (
            <div className="text-center py-20 bg-muted/30 rounded-3xl border border-dashed border-border">
                <p className="text-lg text-muted-foreground">No additional posts found.</p>
            </div>
        )}
      </div>
      
      {/* Newsletter CTA */}
      <NewsletterCTA />
    </div>
  );
};

export default BlogIndexPage;
